export enum RAndDIndustry {
  AGRICULTURE = 'Agriculture',
  ANIMAL_HEALTH = 'Animal Health',
  BIOPHARMA = 'Biopharma',
  DIAGNOSTICS = 'Diagnostics',
  INDUSTRIAL_BIOTECH = 'Industrial Biotech',
  CRO = 'CRO',
}

export enum AcademicField {
  BIOCHEMISTRY_AND_CHEMICAL_BIOLOGY = 'Biochemistry and Chemical Biology',
  BIOENGINEERING = 'Bioengineering',
  ECOLOGY_AND_EVOLUTIONARY_BIOLOGY = 'Ecology and Evolutionary Biology',
  GENETICS_AND_GENOMICS = 'Genetics and Genomics',
  MICROBIOLOGY = 'Microbiology',
  MOLECULAR_AND_CELL_BIOLOGY = 'Molecular and Cell Biology',
  SYNTHETIC_BIOLOGY = 'Synthetic Biology',
  OTHER = 'Other',
}

export enum AcademicRole {
  GRADUATE_STUDENT = 'Graduate Student',
  LAB_MANAGER = 'Lab Manager',
  POSTDOC = 'Postdoc',
  PROFESSOR = 'Professor',
  RESEARCH_ASSISTANT = 'Research Assistant',
  UNDERGRADUATE = 'Undergraduate',
  OTHER = 'Other',
}
